import { render, staticRenderFns } from "./EmptyTab.vue?vue&type=template&id=3b90ab45&scoped=true"
import script from "./EmptyTab.vue?vue&type=script&lang=ts"
export * from "./EmptyTab.vue?vue&type=script&lang=ts"
import style0 from "./EmptyTab.vue?vue&type=style&index=0&id=3b90ab45&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b90ab45",
  null
  
)

export default component.exports